export const docLinkPreviewInfoValidPeriod = 30 * 60 * 60 * 1000; // 30 minutes
export const maxActiveGetWacInfoOperation = 2;
export const SP_LINK_CLICK_EVENT_LISTENER = 'SP_LINK_CLICK_EVENT_LISTENER';
export const SP_LINK_MOUSEUP_EVENT_LISTENER = 'SP_LINK_MOUSEUP_EVENT_LISTENER';

export const ORIGINALSRC_ATTTIBUTE_NAME = 'originalsrc';
export const SHASH_ATTTIBUTE_NAME = 'shash';
export const DATA_AUTH_ATTTIBUTE_NAME = 'data-auth';
export const RESERVED_PARAM = '&reserved=0';
export const VERIFIED_SAFE_LINK = 'Verified';
